import { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Button, ButtonWithSpinner, ComboBox, InputWithLabel, Modal } from '@reveni-io/reveni-ui'
import { Text } from '@reveni-io/reveni-ui'

import { exportFormatValues, formats } from '@/common/constants'
import AppContext from '@/common/context/app.context'

import { ActionsContainer, MainContainer, OptionContainer } from './styles'

const ExportModal = ({ show, onClose, onExport, exporting }) => {
  const { info } = useContext(AppContext)
  const [format, setFormat] = useState(exportFormatValues.csv)
  const [email, setEmail] = useState(info.userInfo?.email)
  const { t } = useTranslation()

  useEffect(() => {
    setFormat('csv')
    setEmail(info.userInfo?.email)
  }, [info.userInfo?.email, show])

  const handleChangeFormat = e => {
    setFormat(e.target.value)
  }

  const handleChangeEmail = e => {
    setEmail(e.target.value)
  }

  const exportResults = () => {
    onExport({ format, email })
  }

  return (
    <Modal title={t('Exportar envíos')} show={show} onClose={onClose} size="l">
      <MainContainer>
        <Text type="bodyMRegular">{t('Se exportarán los envíos del listado, aplicando los filtros activos')}</Text>
        <OptionContainer>
          <div>
            <ComboBox
              fullWidth
              handleChange={handleChangeFormat}
              menuItems={formats}
              label={t('Formato')}
              value={format}
            />
          </div>
        </OptionContainer>
        <Text type="bodyMRegular">
          {t('Dirección de correo a la que enviar el fichero con el resultado de la exportación')}
        </Text>
        <InputWithLabel onChange={handleChangeEmail} label="Email" value={email} fullWidth />
        <ActionsContainer>
          <Button onClick={onClose} variant="outlined">
            {t('Cancelar')}
          </Button>
          <ButtonWithSpinner
            defaultLabel={t('Exportar')}
            loading={exporting}
            disabled={exporting}
            loadingLabel={t('Exportando')}
            onClick={exportResults}
          />
        </ActionsContainer>
      </MainContainer>
    </Modal>
  )
}

export default ExportModal
